export const api = "https://preprodapi.cinescape.com.kw/api/";
export const av = "3";
export const pt = "WEBSITE";
